import { useEffect, useState } from 'react';
import { supabase } from './App';
import { addIndex, append, compose as C, groupBy as g, indexBy, lensPath, map as m, over, 
    prop as p, propEq, reject } from 'ramda';
import './pult.css';

export const Steps = ({basic, config=false, toggleConfig, event_id,current}) => {
    let myChannel = null;
    const [steps, setSteps] = useState([]);
    const [currentStep, setCurrentStep] = useState(null);
    const [currentMax, setCurrentMax] = useState(null);
    const [types, setTypes] = useState([]);
    const [added, setAdded] = useState([]);
    const [dragOver, setDragOver] = useState({ index: null, position: null });

    const add_step = async () => {
        const new_step = await supabase
            .from("steps")
            .insert({event_id,order:steps.length + 1})
            .select("*, steps_questions(*,questions(*)), events!steps_event_id_fkey(current)")
            .single();
        setSteps([...steps,new_step.data])
    }

    /*   const { data:copied_event, error } = await supabase.rpc('copy_event', {
          p_key: 'võti2-2',
          p_copy_from_id: 7,
          p_date: '2025-10-22'
      })
    
      if (error) console.error(error)
      else console.log('New event id:', data) */

    const subscribeToChanges = () => {
        const handleEvents = (payload) => {
            if(!config) setCurrentStep(payload.new.current);
        };

        if (!current && !myChannel) {
            myChannel = supabase
                .channel("events")
                .on("postgres_changes",{ event: "UPDATE", schema: "salme", table: "events" },handleEvents)
                .subscribe();
        }
    };
    const fetchTypes = async () => {
        const { data } = await supabase.from("types").select("*");
        setTypes(data);
    }

    const fetchSteps = async() => {
        const { data } = await supabase.from("steps")
            .select("*, steps_questions(*,questions(*)), events!steps_event_id_fkey(current,current_max)")
            .eq("event_id",event_id)
            .order("order");
        C(
            setAdded,
            m(C(
                g(p("type_id")),
                p("steps_questions"))),
            indexBy(p("id"))
        )(data)

        setSteps(data);
        if(!config) setCurrentStep(data.find(x => x.events.current === x.id)?.id);
        if(!config) setCurrentMax(data.find(x => x.events.current_max === x.id)?.id);
    };

    const changeCurrent = async x =>  {
        if(!config) {
            const current = await supabase.from('events').update({ current: x }).eq('play', true).single();
        }
        setCurrentStep(x);
    }

    const handleDrop = (type,step) => async e => {
        e.preventDefault();
        e.stopPropagation();
        setDragOver(null);
        const {id,text,shortname} = JSON.parse(e.dataTransfer.getData('application/json'));
        const { data } = await supabase.from('steps_questions')
            .insert({ step_id:step,type_id:type, question_id:id}).select().single();
        C(setAdded,over(lensPath([step,type]),append({...data,questions:{id,text,shortname}})))(added);

    };
    const delete_question = (type,step,id) => async e => {
        e.stopPropagation();
        await supabase.from('steps_questions').delete().eq('id',id);
        C(setAdded,over(lensPath([step,type]),reject(propEq(id,"id"))))(added)
    }

    const handleStepNameChange = (stepId) => e => {
        const newName = e.target.value;
        setSteps(steps =>
            steps.map(step =>step.id === stepId ? { ...step, name: newName, changed:true } : step)
        );
    };

    const handleStepTextChange = (stepId) => e => {
        const newText = e.target.value;
        setSteps(steps =>
            steps.map(step =>step.id === stepId ? { ...step, text: newText, text_changed:true } : step)
        );
    };

    const saveStepName = ({name,id}) => async e => {
        const changedName = await supabase.from("steps").update({ name }).eq('id', id).single();
        if (!changedName.error) {
            setSteps(steps => steps.map(step => step.id === id ? { ...step,changed:false } : step))
        }
    }

    const saveStepText = ({text,id}) => async e => {
        const changedText = await supabase.from("steps").update({ text }).eq('id', id).single();
        if (!changedText.error) {
            setSteps(steps => steps.map(step => step.id === id ? { ...step,text_changed:false } : step))
        }
    }

    const deleteStep = id => async () =>  {
        const new_current = steps[steps.findIndex(x => x.id === id)-1].id;
        setCurrentStep(new_current);
        const current = await supabase.from('events').update({ current: new_current }).eq('play', true).single();
        const deleted = await supabase.from('steps').delete().eq('id',id);
        if (deleted.status === 204) setSteps(reject(propEq(id,"id"),steps))
    }

    const updateStepOrder = async (steps) => {
        const updates = steps.map((s, idx) => ({id: s.id,order: idx + 1}));
        const { error } = await supabase.from("steps").upsert(updates, { onConflict: "id" });
        if (error) console.error("Error updating step order:", error);
    };
    const reorderSteps = async (from, to) => {
        setSteps(xs => {
            const copy = [...xs];
            const [moved] = copy.splice(from, 1);
            copy.splice(to, 0, moved);
            updateStepOrder(copy);
            return copy;
        });
    };

    useEffect(() => {
        fetchTypes();
        fetchSteps();
        if(!current) {
            subscribeToChanges();
            return () => {
                if (myChannel) {
                    myChannel.unsubscribe();
                    myChannel = null;
                }
            };
        } else {
            setCurrentStep(current);
            if (!currentMax) setCurrentMax(currentMax);
        }
    },[current,currentMax]);

    return <div id="steps" className={!config ? "closed" : ""}>
            {!basic ? <div>
                <h2>Sammud</h2>
                <button className="toggle" onClick={() => {toggleConfig(!config)}}>{config ? "✖" : "🖉"}</button>
            </div> : null}
            {addIndex(m)((step, index) => <div 
                onDragOver={e => {
                    e.preventDefault();
                    const raw = e.dataTransfer.getData("text/plain");
                    if (!raw) return;
                    const { type } = JSON.parse(raw);
                    if (type === "step") setDragOver(index);
                }}
                onDragLeave={() => setDragOver(null)}
                onDrop={e => {
                    e.preventDefault();
                    const raw = e.dataTransfer.getData("text/plain");
                    if (!raw) return;
                    const { type, stepIndex } = JSON.parse(raw);
                    if (type !== "step") return;
                    const from = +stepIndex;
                    const to = index;
                    setDragOver(null);
                    if (from !== to) reorderSteps(from, to);
                }}
                onClick={() => {changeCurrent(step.id)}} 
                className={`step ${currentStep === step.id ? "active": ""} ${dragOver === index ? "drag-over" : ""} ${step.text ? "text-step" : ""}`} 
                style={{ transition: "transform 0.2s ease" }} 
                key={step.id}>
                {!basic && config ? 
                    <span className="drag_handle" draggable onDragStart={e => {
                        const payload = { type: "step", stepIndex: index };
                        e.dataTransfer.setData("text/plain", JSON.stringify(payload));
                    }}>
                        ☰
                    </span> 
                : null}

                {!basic && config ? <button className="delete_button" type="button" onClick={deleteStep(step.id)}>✖</button> : null}
                {!basic && config ? <div className="stepname_edit">
                        <input className="step_title_input" 
                            onKeyDown={e => {if (e.key === "Enter" && step.changed) {saveStepName(step)(e);}}}
                            onChange={handleStepNameChange(step.id)} value={step.name}/>
                        {step.changed ? <button className="change_btn" onClick={saveStepName(step)}>✔</button> : null}
                    </div> : 
                    <h3>{step.name}</h3>}
                {!basic && config ? <>
                    <div className="question_box step_text_input">
                        <p className="label">tekst</p>
                        <textarea name="text" onKeyDown={e => {if (e.key === "Enter" && step.text_changed) {saveStepText(step)(e);}}}
                                onChange={handleStepTextChange(step.id)} value={step.text}/>
                        {step.text_changed ? <button className="change_btn" onClick={saveStepText(step)}>✔</button> : null}
                    </div>
                    <div className="conf">
                        {m(x => <div key={x.name} className="question_box" onDragOver={x => x.preventDefault()} onDrop={handleDrop(x.id,step.id)}>
                            <p className="label">{x.name}</p>
                            {m(b => 
                                <button className="question" key={x?.id+step?.id+b?.id} 
                                    onClick={delete_question(x.id,step.id,b.id)}>{b.questions.shortname || b.questions.text}</button>,
                            added?.[step?.id]?.[x?.id] || [])}
                        </div> ,types)}
                    </div></> : null}
            </div>, steps)}
            {!basic && config ? <button type="button" onClick={add_step} className="add_new">+</button> : null}
        </div>
}